var map = {
	"./thumb_audio.svg": "fefd",
	"./thumb_compressed.svg": "f202",
	"./thumb_culture_daily.svg": "2b8c",
	"./thumb_document.svg": "299c",
	"./thumb_document_doc.svg": "8d79",
	"./thumb_document_docx.svg": "7fe5",
	"./thumb_document_pdf.png": "07e6",
	"./thumb_document_pdf.svg": "9ab4",
	"./thumb_document_txt.svg": "ed5f",
	"./thumb_image.svg": "28ba",
	"./thumb_others.svg": "0654",
	"./thumb_presentation.svg": "acb9",
	"./thumb_spreadsheet.svg": "5e0f",
	"./thumb_video.svg": "a1a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9897";